import React from "react";
import SEO from "./SEO";
import { buildPlayStoreUrl } from "./funnel/utm";
import PlayStoreCTA from "./funnel/PlayStoreCTA";

const CHANNEL_NAME = "SCHOOGLINK | PATHYACHARYA | KUNJI AI";
const YOUTUBE_CHANNEL_URL =
  "https://www.youtube.com/channel/UCgXdXVjxtBcKP_4ta_jZj9A";

const playlistUrl = (id) => `https://www.youtube.com/playlist?list=${id}`;
const playlistEmbedUrl = (id) =>
  `https://www.youtube.com/embed/videoseries?list=${id}`;
const watchUrl = (videoId, listId) =>
  `https://www.youtube.com/watch?v=${videoId}&list=${listId}`;
const thumbUrl = (videoId) => `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;

// Kunji AI strategy playlist — "Study with Kunji AI"
// Playlist on YouTube has 3 titles uploaded twice each. We list each title
// once, using the newer video ID. If the older duplicates get removed from
// the playlist, no change needed here.
const kunjiAIPlaylistId = "PLr7l6-G1DcmxSXeAaO09rXCBePdyz1ZjP";
const kunjiAIVideos = [
  {
    id: "d3-liLjP99Y",
    title: "Kunji AI से 35 पासिंग मार्क्स कैसे प्राप्त करें",
    publishedAt: "2025-11-02",
    tag: "पासिंग",
  },
  {
    id: "VSZFWHXIMNQ",
    title: "Kunji AI से 75–80 मार्क्स (1st Division) कैसे प्राप्त करें",
    publishedAt: "2025-11-02",
    tag: "1st Division",
  },
  {
    id: "jVNrFUSqOcQ",
    title: "Kunji AI से 90+ मार्क्स (टॉपर्स के लिए)",
    publishedAt: "2025-11-02",
    tag: "टॉपर",
  },
];

// How-to playlist — "How to use Pathyacharya App" (short tutorials)
// Ordered as a learning path (beginner → advanced), not chronologically.
const howToPlaylistId = "PLr7l6-G1DcmyNZpDvebBXaFhUP4PlCXMg";
const howToVideos = [
  {
    id: "IW9NdRJsWSU",
    title: "पाठ्यचर्या App कैसे चलाएँ?",
    publishedAt: "2026-06-01",
    tag: "शुरुआत",
  },
  {
    id: "rAQipqDTVNA",
    title: "अपना Course कैसे सेट करें? (बोर्ड, कक्षा, विषय)",
    publishedAt: "2026-06-01",
    tag: "Setup",
  },
  {
    id: "LjBN1fvAY9Y",
    title: "बोर्ड, कक्षा और विषय कैसे बदलें?",
    publishedAt: "2026-06-01",
    tag: "Setup",
  },
  {
    id: "j5TdlZBJwRc",
    title: "किसी भी टॉपिक का वीडियो लेसन कैसे देखें?",
    publishedAt: "2026-06-01",
    tag: "पढ़ाई",
  },
  {
    id: "HDRmn1WcuSs",
    title: "हर चैप्टर में क्या-क्या मिलता है?",
    publishedAt: "2026-06-01",
    tag: "पढ़ाई",
  },
  {
    id: "VPgNCCVgb9I",
    title: "MCQ प्रैक्टिस और AI Answer कैसे पाएँ?",
    publishedAt: "2026-06-01",
    tag: "अभ्यास",
  },
  {
    id: "FRZLKi52Z2I",
    title: "लघु उत्तरीय प्रश्न का AI Solution कैसे पाएँ?",
    publishedAt: "2026-06-01",
    tag: "अभ्यास",
  },
  {
    id: "8QKWmQhdqdY",
    title: "कुंजी AI से कोई भी सवाल कैसे पूछें?",
    publishedAt: "2026-06-01",
    tag: "Kunji AI",
  },
  {
    id: "kp-3y3_asnA",
    title: "पिछले सालों के बोर्ड प्रश्न (PYQP) + AI Analysis",
    publishedAt: "2026-06-01",
    tag: "बोर्ड",
  },
  {
    id: "55NacYVKwCE",
    title: "मॉडल टेस्ट पेपर कैसे हल करें?",
    publishedAt: "2026-06-01",
    tag: "बोर्ड",
  },
  {
    id: "D3iJW6v_Wvc",
    title: "लाइव चैप्टर टेस्ट कैसे दें?",
    publishedAt: "2026-06-01",
    tag: "Live Test",
  },
  {
    id: "T0V1Yh-1KdM",
    title: "अपनी पढ़ाई की Progress कैसे देखें?",
    publishedAt: "2026-06-01",
    tag: "Progress",
  },
  {
    id: "90E44MhVuRs",
    title: "Coins, Rank और Leaderboard कैसे काम करते हैं?",
    publishedAt: "2026-06-01",
    tag: "Rewards",
  },
  {
    id: "VsGLe2Yvb8w",
    title: "पाठ्यचर्या Premium कैसे लें?",
    publishedAt: "2026-06-01",
    tag: "Premium",
  },
];

// BSEB Class 10 PYQ playlist. Newest first.
const pyqPlaylistId = "PLr7l6-G1DcmybhOFewFLZuaXYkSOAg7_m";
const pyqVideos = [
  {
    id: "D_kfdUjnnDs",
    title: "ब्रिटिश आर्थिक नीतियों का भारतीय कृषि पर क्या प्रभाव पड़ा?",
    publishedAt: "2026-04-30",
    tag: "इतिहास",
  },
  {
    id: "uGIg_elTAds",
    title: "बंगाल विभाजन को कब रद्द किया गया था?",
    publishedAt: "2026-04-29",
    tag: "इतिहास",
  },
  {
    id: "3gB_2Pobo3U",
    title: "पादपों में परिवहन — जैव प्रक्रम (BSEB 2025)",
    publishedAt: "2026-04-27",
    tag: "जीवविज्ञान",
  },
  {
    id: "gLCsYsi861A",
    title: "मनुष्य में पोषण",
    publishedAt: "2026-04-26",
    tag: "जीवविज्ञान",
  },
  {
    id: "ooG47J9fwqU",
    title: "धातु और अधातु — भाग 2",
    publishedAt: "2026-04-25",
    tag: "रसायन विज्ञान",
  },
  {
    id: "YxI5WBOXHi0",
    title: "धातु और अधातु — भाग 1",
    publishedAt: "2026-04-24",
    tag: "रसायन विज्ञान",
  },
  {
    id: "5jOcq0ydVvQ",
    title: "प्रकाश की किरणें",
    publishedAt: "2026-04-23",
    tag: "भौतिकी",
  },
  {
    id: "EB0rpM5EkO0",
    title: "फोकस दूरी तथा वक्रता त्रिज्या में संबंध",
    publishedAt: "2026-04-21",
    tag: "भौतिकी",
  },
  {
    id: "A2sAofCkKvM",
    title: "सिद्ध करें कि (5 − √3) एक अपरिमेय संख्या है।",
    publishedAt: "2026-04-20",
    tag: "गणित",
  },
  {
    id: "jF3lmriuiJE",
    title: "0.105 को p / (2ⁿ × 5ᵐ) के रूप में लिखिए।",
    publishedAt: "2026-04-19",
    tag: "गणित",
  },
];

const formatDate = (iso) =>
  new Date(iso).toLocaleDateString("hi-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });

const VideoCard = ({ video, listId }) => (
  <a
    href={watchUrl(video.id, listId)}
    target="_blank"
    rel="noopener noreferrer"
    className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl border border-gray-200 transition-all"
  >
    <div className="relative aspect-video bg-gray-100 overflow-hidden">
      <img
        src={thumbUrl(video.id)}
        alt={video.title}
        loading="lazy"
        className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
      />
      <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/30 transition-colors">
        <div className="w-14 h-14 rounded-full bg-red-600 flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
          <span className="text-white text-xl ml-1" aria-hidden>
            ▶
          </span>
        </div>
      </div>
    </div>
    <div className="p-4">
      {video.tag && (
        <span className="inline-block text-xs font-semibold text-blue-600 bg-blue-50 px-2 py-0.5 rounded-full mb-2">
          {video.tag}
        </span>
      )}
      <h3 className="text-base font-semibold text-gray-900 line-clamp-2 group-hover:text-blue-600 transition-colors">
        {video.title}
      </h3>
      <p className="mt-2 text-xs text-gray-500">
        {formatDate(video.publishedAt)}
      </p>
    </div>
  </a>
);

const VideoSection = ({
  id,
  eyebrow,
  heading,
  subheading,
  playlistId,
  videos,
  bgClass,
}) => (
  <section id={id} className={`py-12 px-4 ${bgClass}`}>
    <div className="max-w-6xl mx-auto">
      <div className="text-center mb-8">
        <p className="text-sm font-semibold text-blue-600 uppercase tracking-wide">
          {eyebrow}
        </p>
        <h2 className="mt-1 text-2xl sm:text-3xl font-bold text-gray-900">
          {heading}
        </h2>
        {subheading && (
          <p className="mt-2 text-gray-600 max-w-2xl mx-auto">{subheading}</p>
        )}
      </div>

      <div className="max-w-4xl mx-auto mb-8">
        <div className="relative w-full overflow-hidden rounded-2xl shadow-lg border border-gray-200 bg-black aspect-video">
          <iframe
            src={playlistEmbedUrl(playlistId)}
            title={heading}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            loading="lazy"
            className="absolute inset-0 w-full h-full"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {videos.map((v) => (
          <VideoCard key={v.id} video={v} listId={playlistId} />
        ))}
      </div>

      <div className="mt-8 text-center">
        <a
          href={playlistUrl(playlistId)}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg px-5 py-3 transition-colors shadow-sm"
        >
          YouTube पर पूरी playlist देखें →
        </a>
      </div>
    </div>
  </section>
);

const Blog = () => {
  const playStoreUrl = buildPlayStoreUrl({
    medium: "videos_page",
    campaign: "video_library",
    term: "play-badge",
  });

  const allVideos = [...kunjiAIVideos, ...howToVideos, ...pyqVideos];

  const playlistIdFor = (video) => {
    if (kunjiAIVideos.includes(video)) return kunjiAIPlaylistId;
    if (howToVideos.includes(video)) return howToPlaylistId;
    return pyqPlaylistId;
  };

  return (
    <div className="mt-[100px]">
      <SEO
        title="Pathyacharya Tutorial Videos | Kunji AI Strategy, ऐप ट्यूटोरियल, BSEB PYQ"
        description="Kunji AI से 35 / 75-80 / 90+ marks कैसे पाएँ। Pathyacharya ऐप कैसे चलाएँ — login, बोर्ड चुनें, Kunji AI, अभ्यास। साथ ही BSEB Class 10 के previous year questions के step-by-step video समाधान, हिंदी में।"
        url="https://schooglink.com/blog"
        image={thumbUrl(kunjiAIVideos[0].id)}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "ItemList",
          name: "Pathyacharya Videos — Tutorials and BSEB PYQ Solutions",
          numberOfItems: allVideos.length,
          itemListElement: allVideos.map((v, i) => ({
            "@type": "ListItem",
            position: i + 1,
            url: watchUrl(v.id, playlistIdFor(v)),
            name: v.title,
          })),
        }}
      />

      {/* Header */}
      <section className="bg-gradient-to-b from-blue-50 to-white py-12 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <a
            href={YOUTUBE_CHANNEL_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-yellow-100 hover:bg-yellow-200 border border-yellow-400 rounded-full px-3 py-1 mb-4 transition-colors"
            aria-label="Schooglink YouTube चैनल पर जाएँ"
          >
            <p className="text-xs sm:text-sm font-bold text-yellow-800">
              🎥 Free Videos · {CHANNEL_NAME} →
            </p>
          </a>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 leading-snug">
            <span className="block">Pathyacharya Tutorial (गाइड) Videos</span>
            <span className="block text-blue-600 mt-2">
              Kunji AI strategy + ऐप ट्यूटोरियल +
            </span>
            <span className="block text-blue-600 mt-2">
              बोर्ड परीक्षा के कुछ उदाहरण (समाधान के साथ)
            </span>
          </h1>
          <p className="text-lg sm:text-xl text-gray-700 mt-4">
            समझें कि Kunji AI से कैसे और कितने marks possible हैं, ऐप कैसे
            चलाएँ, और BSEB Class 10 के पिछले वर्ष के कुछ प्रश्नों का video
            समाधान।
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
            <a
              href="#kunji-ai"
              className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg px-5 py-3 transition-colors"
            >
              Kunji AI Strategy
            </a>
            <a
              href="#how-to"
              className="inline-flex items-center gap-2 bg-white hover:bg-gray-50 text-gray-900 border border-gray-300 font-semibold rounded-lg px-5 py-3 transition-colors"
            >
              ऐप ट्यूटोरियल
            </a>
            <a
              href="#pyq"
              className="inline-flex items-center gap-2 bg-white hover:bg-gray-50 text-gray-900 border border-gray-300 font-semibold rounded-lg px-5 py-3 transition-colors"
            >
              PYQ समाधान
            </a>
            <PlayStoreCTA href={playStoreUrl} />
          </div>
        </div>
      </section>

      <VideoSection
        id="kunji-ai"
        eyebrow="कुंजी AI से पढ़ाई"
        heading="Kunji AI से Marks कैसे पाएँ"
        subheading={`हर level के लिए strategy — passing से लेकर topper तक। ${kunjiAIVideos.length} videos`}
        playlistId={kunjiAIPlaylistId}
        videos={kunjiAIVideos}
        bgClass="bg-white"
      />

      <VideoSection
        id="how-to"
        eyebrow="शुरू करने के लिए"
        heading="ऐप का उपयोग कैसे करें"
        subheading={`${howToVideos.length} short tutorials — App सेटअप से लेकर Kunji AI doubt, प्रैक्टिस और लाइव टेस्ट तक का पूरा रास्ता।`}
        playlistId={howToPlaylistId}
        videos={howToVideos}
        bgClass="bg-gray-50"
      />

      <VideoSection
        id="pyq"
        eyebrow="पिछले वर्षों के प्रश्न"
        heading="BSEB Class 10 — Video Solutions (a few examples)"
        subheading={`${pyqVideos.length} step-by-step solutions — गणित, विज्ञान, इतिहास के सवालों के जवाब हिंदी में। (ऐप पर संपूर्ण समाधान उपलब्ध हैं)`}
        playlistId={pyqPlaylistId}
        videos={pyqVideos}
        bgClass="bg-white"
      />

      {/* Final CTA */}
      <section className="py-14 px-4 bg-blue-600 text-white">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl font-bold mb-3">
            पूरी पढ़ाई एक ही app में
          </h2>
          <p className="text-lg mb-6 text-blue-100">
            20,000+ video lectures, AI doubt solving, daily quizzes — Pathyacharya
            पर 7 दिन free trial के साथ।
          </p>
          <PlayStoreCTA
            href={playStoreUrl}
            badgeClassName="h-14 sm:h-16"
            qrSize="w-24 h-24"
            className="justify-center"
          />
        </div>
      </section>
    </div>
  );
};

export default Blog;
